import { createSlice } from "@reduxjs/toolkit";

const initialState = 100;

const zoomSlice = createSlice({
  name: "zoomLevel",
  initialState,
  reducers: {
    setZoomLevel: (_state, action) => action.payload,
  },
});

export const { setZoomLevel } = zoomSlice.actions;
export default zoomSlice.reducer;
